import { cva } from 'class-variance-authority';

export const headingVariants = cva(['font-raleway'], {
  variants: {
    intent: {
      h1: ['text-7xl'],
      h2: ['text-6xl'],
      h3: ['text-5xl'],
      h4: ['text-4xl'],
      h5: ['text-3xl'],
      h6: ['text-2xl'],
    },
    padding: {
      sm: ['pt-2', 'md:pt-4', 'pb-2'],
      md: ['pt-4', 'md:pt-8', 'pb-2'],
      base: ['pt-6', 'md:pt-12', 'pb-2', 'md:pb-6'],
      noPadding: ['pt-0', 'md:pt-0', 'pb-0'],
    },
    shouldTruncate: {
      true: ['truncate'],
    },
  },
  defaultVariants: {
    intent: 'h2',
  },
});
